import { TheWestSection } from '@news-mono/common'
import { metrics, sectionThemeOverrider } from '@news-mono/component-library'
import { Election, GetRouteAdTargeting, PageType } from '@news-mono/web-common'
import { layout } from '../../../App.routing'

type CreateElectionPageArgs = {
    heading: string
    description: string
    getAdTargeting: GetRouteAdTargeting
    election: Election
}

export const createElectionLandingPage = ({
    heading,
    description,
    getAdTargeting,
    election,
}: CreateElectionPageArgs): PageType<TheWestSection> => {
    return {
        kind: 'page',
        heading,
        pageType: 'static',
        section: 'default',
        hideHeading: true,
        adTargeting: getAdTargeting('home', 'default', 'home'),
        pageMeta: {
            description,
        },
        socialMeta: {
            description,
        },
        compositions: [
            layout.composition({
                type: 'box',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'election-navigation',
                            props: {
                                election,
                                activePage: 'updates',
                                headingLevel: 'h1',
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}
